import { useNavigate } from 'react-router-dom'

import { rollbar } from '../infra/rollbar.config'
import { useAuthStore } from '../stores/auth.store'
import type { ResponseAPI } from '../types/response-api.type'
import { useToast } from './use-toast'

export type CheckStatusOnRequest = {
  status: number
  message: string
  showToastInfo?: boolean
  showToastSuccess?: boolean
  callback?: (payload?: ResponseAPI) => any
}

export const useResolveRequestHook = () => {
  const { toast } = useToast()
  const navigate = useNavigate()
  const {
    actions: { clearAll },
  } = useAuthStore()
  const checkStatusOnRequest = (props: CheckStatusOnRequest) => {
    const {
      callback,
      message,
      status,
      showToastSuccess = false,
      showToastInfo = false,
    } = props

    switch (status) {
      case 200:
      case 202:
      case 204:
      case 203:
      case 400:
        showToastInfo &&
          toast.info({
            title: message,
          })

        showToastSuccess &&
          toast.success({
            title: message,
          })

        callback?.()
        break
      case 401:
        toast.info({
          title: message,
        })
        clearAll()
        setTimeout(() => {
          navigate('/login')
        }, 3000)
        break
      default:
        toast.error({
          title: message,
        })
        rollbar.error(message, {
          status,
        })
    }
  }

  return {
    checkStatusOnRequest,
  }
}
